import React from "react"
import styled from "styled-components"
import Loader from "./Loader"
import { useReport } from "@src/context/ReportContext"
import { Icon } from "semantic-ui-react"


const ModalContainer = styled.div`
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column; /* Permite que o conteúdo se empilhe */
  justify-content: center;
  align-items: center;
  background-color: white; /* A caixa em si é branca */
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease-in-out; /* Transição suave para ambos os estados */
  overflow: hidden; /* Garante que o conteúdo não vaze */

  ${(props) =>
    props.$isMinimized
      ? `
    bottom: 20px;
    right: 20px;
    width: 700px; /* Aumentado para caber o texto no minimizado */
    height: 80px; /* Altura menor quando minimizado */
    padding: 10px; /* Padding menor para o estado minimizado */
    border: 1px solid #ddd; /* Borda para o estado minimizado */
    /* Remove centralização para o estado minimizado */
    top: auto;
    left: auto;
    transform: none;
  `
      : `
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* Centraliza o modal na tela */
    width: 550px; /* Largura para o modal normal (já estava ok) */
    max-width: 90vw; /* Garante responsividade em telas menores */
    min-height: 200px; /* Altura mínima */
    padding: 40px; /* Padding maior para o estado normal */
  `}

  /* Overlay de fundo semi-transparente que cobre a tela inteira quando o modal NÃO está minimizado */
  ${(props) =>
    !props.$isMinimized &&
    `
    &:before {
      content: '';
      position: fixed; /* Usa fixed para cobrir toda a viewport */
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(255, 255, 255, 0.8); /* Fundo branco semi-transparente */
      z-index: -1; /* Fica atrás da caixa do modal */
    }
  `}
`

const ModalInnerContent = styled.div`
  display: flex;
  align-items: center; /* Alinha itens verticalmente ao centro */
  width: 100%;
  height: 100%;
  position: relative; /* Para posicionar o botão de minimizar */

  ${(props) =>
    props.$isMinimized
      ? `
      flex-direction: row; /* Loader e texto/botão lado a lado no minimizado */
      justify-content: space-between; /* Espaça o loader/texto do botão */
      padding: 0 10px; /* Adiciona padding horizontal para não colar nas bordas */
    `
      : `
      flex-direction: column; /* Loader em cima, texto/botão embaixo no normal */
      justify-content: center; /* Centraliza verticalmente */
    `}

  p {
    /* Ajuste de margem e tamanho da fonte para ambos os estados */
    margin-top: ${(props) => (props.$isMinimized ? "0" : "20px")}; /* 0 no minimizado, 20px no normal */
    font-size: ${(props) => (props.$isMinimized ? "0.9em" : "1.2em")};
    line-height: 1.2;
    color: #333;
    
    ${(props) =>
      props.$isMinimized
        ? `
        white-space: nowrap; /* Evita quebra de linha no texto minimizado */
        overflow: hidden; /* Esconde o excesso de texto */
        text-overflow: ellipsis; /* Adiciona reticências se o texto for muito longo */
        flex-grow: 1; /* Permite que o texto ocupe o espaço disponível */
        margin-right: 10px; /* Espaçamento entre o texto e o botão */
      `
        : `
        white-space: normal; /* Permite quebra de linha no texto normal */
        text-align: center; /* Centraliza o texto no modal normal */
        max-width: 100%; /* Ocupa a largura total disponível */
      `}
  }

  /* Wrapper para o Loader para aplicar o scale */
  .loader-wrapper {
    ${(props) =>
      props.$isMinimized &&
      `
      transform: scale(0.4); /* Reduz ainda mais o tamanho do loader quando minimizado */
      transform-origin: center;
      margin-top: 0; /* Ajuste de posição para centralizar melhor */
      flex-shrink: 0; /* Impede que o loader encolha */
    `}
  }

  .download-button {
    ${(props) =>
      props.$isMinimized
        ? `
        margin-top: 0; /* Remove margem superior no minimizado */
        flex-shrink: 0; /* Impede que o botão encolha */
      `
        : `
        margin-top: 10px; /* Mantém margem superior no normal */
      `}
    padding: 8px 15px;
    background-color: #2185d0;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
`

const MinimizeButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
  color: #666;
  &:hover {
    color: #333;
  }
`

const LoadingModal = () => {
  const { isGenerating, currentPageProgress, totalItemsFetched, isMinimized, toggleMinimize, generatedReportData } =
    useReport()

  if (!isGenerating && !generatedReportData) return null

  const modalText = isGenerating
    ? `Gerando relatório detalhado... ${
        currentPageProgress > 0 ? `(Página ${currentPageProgress}, ${totalItemsFetched} registros)` : ""
      }`
    : `Relatório pronto! Clique para baixar.`

  return (
    <ModalContainer $isMinimized={isMinimized}>
      <ModalInnerContent $isMinimized={isMinimized}>
        {!isMinimized && (
          <MinimizeButton onClick={toggleMinimize} aria-label="Minimizar Modal">
            <Icon name="minus" />
          </MinimizeButton>
        )}

        {isGenerating && (
          <div className="loader-wrapper">
            <Loader />
          </div>
        )}
        <p>{modalText}</p>
        {generatedReportData && !isGenerating && (
          <button
            onClick={() => document.getElementById("csv-download-transacoes").click()}
            className="download-button"
          >
            Baixar Agora
          </button>
        )}
      </ModalInnerContent>
    </ModalContainer>
  )
}

export default LoadingModal
